import { Card, CardContent, CardHeader, Grid, InputAdornment } from '@mui/material'
import ArgonBox from 'components/ArgonBox'
import ArgonInput from 'components/ArgonInput'
import ArgonTypography from 'components/ArgonTypography'
import { CustomDescrypt } from 'global/func'
import { postDataWithResponse } from 'global/postFunc'
import React, { useEffect, useState } from 'react'
import userStore from 'store/userStore'

const DetailKomponen = ({ dataKomponen }) => {
    const { user, addReq } = userStore(state => ({ user: state.user, addReq: state.addReq }));
    const decryptedUser = (user === null || user === undefined || user === '') ? "" : JSON.parse(CustomDescrypt(user));

    const [arrRek, setArrRek] = useState([])

    useEffect(() => {
        if (dataKomponen.kode_rekening_akun !== undefined) {
            let txt = dataKomponen.kode_rekening_akun;
            let arr = txt.split('.');
            setArrRek(arr)
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [dataKomponen])

    const [kec, setKec] = useState([])
    const [desa, setDesa] = useState([])

    const reqKec = () => {
        addReq()
        postDataWithResponse(
            `/kecamatan/filter`,
            {
                id_kec: dataKomponen.kec
            },
            decryptedUser,
            (res) => {
                console.log(res);
                setKec(res)
            },
            (res) => {
                console.log(res)
            }
        )
    }

    const reqDesa = () => {
        addReq()
        postDataWithResponse(
            `/desa/filter`,
            {
                id_desa: dataKomponen.desa
            },
            decryptedUser,
            (res) => {
                setDesa(res)
            },
            (res) => {
                console.log(res)
            }
        )
    }

    useEffect(() => {
        if (dataKomponen.penerima_manfaat === 'Off Site') {
            reqKec()
            reqDesa()
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [dataKomponen])

    return (
        <Card>
            <CardHeader
                title={
                    <ArgonTypography variant='subtitle2' fontWeight="bold">Lengkapi Data</ArgonTypography>
                }
            />
            <CardContent>
                <ArgonBox mb={1}>
                    <Grid container spacing={2} justifyContent='center'>
                        {
                            (arrRek[0] === '5' && arrRek[1] === '2') && (
                                <>
                                    <Grid item lg={3} md={6} xs={12}>
                                        <ArgonBox mb={1} ml={0.5}>
                                            <ArgonTypography component="label" variant="caption" fontWeight="bold">
                                                PDN
                                            </ArgonTypography>
                                        </ArgonBox>
                                        <ArgonInput
                                            type="text"
                                            required
                                            size="medium"
                                            value={dataKomponen.pdn  || ''}
                                            disabled
                                        />
                                    </Grid>
                                    <Grid item lg={3} md={6} xs={12}>
                                        <ArgonBox mb={1} ml={0.5}>
                                            <ArgonTypography component="label" variant="caption" fontWeight="bold">
                                                TKDN
                                            </ArgonTypography>
                                        </ArgonBox>
                                        <ArgonInput
                                            type="text"
                                            required
                                            size="medium"
                                            value={dataKomponen.tkdn  || ''}
                                            autoComplete='off'
                                            endAdornment={
                                                <InputAdornment position="end" fontSize='small'>
                                                    <ArgonTypography fontSize='small'>%</ArgonTypography>
                                                </InputAdornment>
                                            }
                                            disabled
                                        />
                                    </Grid>
                                </>
                            )
                        }
                        <Grid item lg={3} md={6} xs={12}>
                            <ArgonBox mb={1} ml={0.5}>
                                <ArgonTypography component="label" variant="caption" fontWeight="bold">
                                    Mekanisme Pelaksanaan
                                </ArgonTypography>
                            </ArgonBox>
                            <ArgonInput
                                type="text"
                                required
                                size="medium"
                                value={dataKomponen.metode_pengadaan  || ''}
                                autoComplete='off'
                                disabled
                            />
                        </Grid>
                        {
                            dataKomponen.metode_pengadaan === 'Penyedia' &&
                            <Grid item lg={3} md={6} xs={12}>
                                <ArgonBox mb={1} ml={0.5}>
                                    <ArgonTypography component="label" variant="caption" fontWeight="bold">
                                        Pemilihan Penyedia
                                    </ArgonTypography>
                                </ArgonBox>
                                <ArgonInput
                                    type="text"
                                    required
                                    size="medium"
                                    value={dataKomponen.pemilihan_penyedia  || ''}
                                    autoComplete='off'
                                    disabled
                                />
                            </Grid>
                        }
                    </Grid>
                </ArgonBox>
                {
                    dataKomponen.metode_pengadaan === 'Penyedia' &&
                    <ArgonBox mb={1}>
                        <ArgonBox ml={0.5}>
                            <ArgonTypography component="label" variant="caption" fontWeight="bold">
                                Kontrak
                            </ArgonTypography>
                        </ArgonBox>
                        <Grid container spacing={2} justifyContent='center'>
                            <Grid item lg={3} md={6} xs={12}>
                                <ArgonBox mb={1} ml={0.5}>
                                    <ArgonTypography component="label" variant="caption" fontWeight="bold">
                                        No. Kontrak / SPK
                                    </ArgonTypography>
                                </ArgonBox>
                                <ArgonInput
                                    type="text"
                                    size="medium"
                                    value={dataKomponen.no_kontrak  || ''}
                                    autoComplete='off'
                                    disabled
                                />
                            </Grid>
                            <Grid item lg={3} md={6} xs={12}>
                                <ArgonBox mb={1} ml={0.5}>
                                    <ArgonTypography component="label" variant="caption" fontWeight="bold">
                                        Tanggal Kontrak
                                    </ArgonTypography>
                                </ArgonBox>
                                <ArgonInput
                                    type="date"
                                    placeholder="Date"
                                    size="medium"
                                    value={dataKomponen.tgl_kontrak || ''}
                                    autoComplete='off'
                                    disabled
                                />
                            </Grid>
                            <Grid item lg={3} md={6} xs={12}>
                                <ArgonBox mb={1} ml={0.5}>
                                    <ArgonTypography component="label" variant="caption" fontWeight="bold">
                                        Nama Penyedia
                                    </ArgonTypography>
                                </ArgonBox>
                                <ArgonInput
                                    type="text"
                                    size="medium"
                                    value={dataKomponen.nama_penyedia || ''}
                                    autoComplete='off'
                                    disabled
                                />
                            </Grid>
                            <Grid item lg={3} md={6} xs={12}>
                                <ArgonBox mb={1} ml={0.5}>
                                    <ArgonTypography component="label" variant="caption" fontWeight="bold">
                                        Nilai Kontrak
                                    </ArgonTypography>
                                </ArgonBox>
                                <ArgonInput
                                    type="text"
                                    size="medium"
                                    value={dataKomponen.nilai_kontrak || ''}
                                    autoComplete='off'
                                    startAdornment={
                                        <InputAdornment position="start">
                                            <ArgonTypography component="label" variant="caption" >
                                                Rp
                                            </ArgonTypography>
                                        </InputAdornment>
                                    }
                                    disabled
                                />
                            </Grid>
                            <Grid item lg={3} md={6} xs={12}>
                                <ArgonBox mb={1} ml={0.5}>
                                    <ArgonTypography component="label" variant="caption" fontWeight="bold">
                                        Waktu Pelaksanaan
                                    </ArgonTypography>
                                </ArgonBox>
                                <ArgonInput
                                    type="text"
                                    size="medium"
                                    value={dataKomponen.waktu_pelaksanaan || ''}
                                    autoComplete='off'
                                    disabled
                                    endAdornment={
                                        <InputAdornment position="end">
                                            <ArgonTypography component="label" variant="caption" >
                                                Hari
                                            </ArgonTypography>
                                        </InputAdornment>
                                    }
                                />
                            </Grid>
                            <Grid item lg={3} md={6} xs={12}>
                                <ArgonBox mb={1} ml={0.5}>
                                    <ArgonTypography component="label" variant="caption" fontWeight="bold">
                                        Tanggal Mulai
                                    </ArgonTypography>
                                </ArgonBox>
                                <ArgonInput
                                    type="date"
                                    placeholder="Date"
                                    size="medium"
                                    value={dataKomponen.tgl_mulai || ''}
                                    autoComplete='off'
                                    disabled
                                />
                            </Grid>
                            <Grid item lg={3} md={6} xs={12}>
                                <ArgonBox mb={1} ml={0.5}>
                                    <ArgonTypography component="label" variant="caption" fontWeight="bold">
                                        Tanggal Selesai
                                    </ArgonTypography>
                                </ArgonBox>
                                <ArgonInput
                                    type="date"
                                    placeholder="Date"
                                    size="medium"
                                    value={dataKomponen.tgl_selesai || ''}
                                    autoComplete='off'
                                    disabled
                                />
                            </Grid>
                            <Grid item lg={3} md={6} xs={12}>
                                <ArgonBox mb={1} ml={0.5}>
                                    <ArgonTypography component="label" variant="caption" fontWeight="bold">
                                        Tanggal Serah Terima
                                    </ArgonTypography>
                                </ArgonBox>
                                <ArgonInput
                                    type="date"
                                    placeholder="Date"
                                    size="medium"
                                    value={dataKomponen.tgl_serah_terima || ''}
                                    autoComplete='off'
                                    disabled
                                />
                            </Grid>
                        </Grid>
                    </ArgonBox>
                }
                {
                    dataKomponen.metode_pengadaan !== '' &&
                    <ArgonBox mb={1}>
                        <ArgonBox ml={0.5}>
                            <ArgonTypography component="label" variant="caption" fontWeight="bold">
                                Lokasi Pekerjaan
                            </ArgonTypography>
                        </ArgonBox>
                        <Grid container spacing={2} justifyContent='center'>
                            <Grid item lg={3} md={6} xs={12}>
                                <ArgonBox mb={1} ml={0.5}>
                                    <ArgonTypography component="label" variant="caption" fontWeight="bold">
                                        Penerima Manfaat
                                    </ArgonTypography>
                                </ArgonBox>
                                <ArgonInput
                                    type="date"
                                    placeholder="Date"
                                    size="medium"
                                    value={dataKomponen.penerima_manfaat || ''}
                                    autoComplete='off'
                                    disabled
                                />
                            </Grid>
                            {
                                dataKomponen.penerima_manfaat === 'On Site' &&
                                (
                                    <Grid item lg={9} md={12} xs={12}>
                                        <ArgonBox mb={1} ml={0.5}>
                                            <ArgonTypography component="label" variant="caption" fontWeight="bold">
                                                Lokasi
                                            </ArgonTypography>
                                        </ArgonBox>
                                        <ArgonInput
                                            required
                                            size="medium"
                                            value={dataKomponen.lokasi}
                                            autoComplete='off'
                                            disabled
                                        />
                                    </Grid>
                                )
                            }
                            {
                                dataKomponen.penerima_manfaat === 'Off Site' &&
                                (
                                    <>
                                        <Grid item lg={3} md={6} xs={12}>
                                            <ArgonBox mb={1} ml={0.5}>
                                                <ArgonTypography component="label" variant="caption" fontWeight="bold">
                                                    Kecamatan
                                                </ArgonTypography>
                                            </ArgonBox>
                                            <ArgonInput
                                                required
                                                size="medium"
                                                value={kec.length > 0 ? kec[0].nama_kec : ''}
                                                autoComplete='off'
                                                disabled
                                            />
                                        </Grid>
                                        <Grid item lg={6} md={6} xs={12}>
                                            <ArgonBox mb={1} ml={0.5}>
                                                <ArgonTypography component="label" variant="caption" fontWeight="bold">
                                                    Desa / Kelurahan
                                                </ArgonTypography>
                                            </ArgonBox>
                                            <ArgonInput
                                                required
                                                size="medium"
                                                value={desa.length > 0 ? desa[0].nama_desa : ''}
                                                autoComplete='off'
                                                disabled
                                            />
                                        </Grid>
                                        {

                                            dataKomponen.geometry_type === 'polyline' ?

                                                <Grid item lg={12} md={6} xs={12}>
                                                    <ArgonBox mb={1} ml={0.5}>
                                                        <ArgonTypography component="label" variant="caption" fontWeight="bold">
                                                            Koordinat (x,y)
                                                        </ArgonTypography>
                                                    </ArgonBox>
                                                    <ArgonInput
                                                        multiline
                                                        rows={7}
                                                        size="medium"
                                                        value={dataKomponen.path}
                                                        autoComplete='off'
                                                        disabled
                                                    />
                                                </Grid>
                                                :
                                                <>
                                                    <Grid item lg={3} md={6} xs={12}>
                                                        <ArgonBox mb={1} ml={0.5}>
                                                            <ArgonTypography component="label" variant="caption" fontWeight="bold">
                                                                Koordinat Latitude
                                                            </ArgonTypography>
                                                        </ArgonBox>
                                                        <ArgonInput
                                                            required={kec.id_kec !== '999'}
                                                            placeholder="Contoh: -5.559958566883871"
                                                            size="medium"
                                                            value={dataKomponen.latitude}
                                                            autoComplete='off'
                                                            disabled
                                                        />
                                                    </Grid>
                                                    <Grid item lg={3} md={6} xs={12}>
                                                        <ArgonBox mb={1} ml={0.5}>
                                                            <ArgonTypography component="label" variant="caption" fontWeight="bold">
                                                                Koordinat Logitude
                                                            </ArgonTypography>
                                                        </ArgonBox>
                                                        <ArgonInput
                                                            required={kec.id_kec !== '999'}
                                                            placeholder="Contoh: 122.83041671853309"
                                                            size="medium"
                                                            value={dataKomponen.longitude}
                                                            autoComplete='off'
                                                            disabled
                                                        />
                                                    </Grid>
                                                </>
                                        }
                                    </>
                                )
                            }
                        </Grid>
                    </ArgonBox>
                }
            </CardContent>
        </Card >
    )
}

export default DetailKomponen